import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, switchMap, tap } from 'rxjs/operators';
import { TaskLibraryApi } from 'shared/sdk';
import { PreloaderService } from 'shared/services/preloader.service';

@Component({
  selector: 'app-task-library-lookup',
  templateUrl: './task-library-lookup.component.html',
  styleUrls: ['./task-library-lookup.component.css']
})
export class TaskLibraryLookupComponent implements OnInit {

  @Input() set resetData(isClear) {
    if (isClear) {
      this.taskSelectedList = [];
      this.taskOptionList = [];
    }
  }
  @Input() set isMultipleSelected(e) {
    this._multipleSelect = e;
    this.maxSelectedItems = e ? 20 : 1;
  }
  @Input() placeholder = 'Task Template';
  @Input() isdisabled = false;

  @Output() getTaskObj: EventEmitter<any> = new EventEmitter;

  searchInput = new Subject<string>();
  librariesLoading = false;
  selectedTask: any;
  whereObj = {};

  maxSelectedItems = 20;
  _multipleSelect = true;

  taskOptionList: any = [];
  taskSelectedList = [];

  constructor(
    private _taskLibraryApi: TaskLibraryApi,
    private _preloaderService: PreloaderService
  ) { }

  ngOnInit() {
    const preselected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';
    const taskSelectedList = (preselected && preselected['taskLibraries']) || [];
    if (taskSelectedList && taskSelectedList.length) {
      this.taskSelectedList = taskSelectedList;
      this.onTaskChange();
      this._preloaderService.showPreloader();
      this.fetchTaskLibraries({ sfdcId: { inq: taskSelectedList } }).subscribe(data => {
        if (data && data.length) {
          this.taskOptionList = data;
        } else {
          this.taskOptionList = [];
        }
        this._preloaderService.hidePreloader();
      }, error => {
        this.taskOptionList = [];
        console.error(error);
        this._preloaderService.hidePreloader();
      });
    }
    this.registerAutocomplete();
  }

  registerAutocomplete() {
    this.searchInput
      .pipe(
        filter(search => search && search.trim().length > 3),
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => this.librariesLoading = true),
        switchMap(search =>
          this.fetchTaskLibraries(this.prepareWhereClause(search))
        )
      ).subscribe(data => {
        if (data && data.length) {
          this.taskOptionList = data;
        } else {
          this.taskOptionList = [];
        }
        this.librariesLoading = false;
      }, err => {
        console.error(err);
        this.taskOptionList = [];
        this.librariesLoading = false;
      }
      );
  }

  prepareWhereClause(search) {
    if (search) {
      return {
        or: [
          // { Name: { like: '%' + search.trim() + '%', options: 'i' } },
          { Task_Name__c: { like: '%' + search.trim() + '%', options: 'i' } }
        ]
      };
    }
    return {};
  }

  fetchTaskLibraries(whereObj?) {
    const filterObj = {
      where: whereObj ? whereObj : {},
      fields: ['id', 'sfdcId', 'Name', 'Task_Name__c'],
      order: 'createdAt desc',
      limit: 200
    }
    return this._taskLibraryApi.find(filterObj);
  }

  onTaskChange() {
    this.getTaskObj.emit(this.taskSelectedList);
  }

  clearTask() {
    this.taskSelectedList = [];
    this.getTaskObj.emit([]);
  }

  clear(val) {
    this.clearTask()
  }
}
